import type { RouteRecordRaw } from 'vue-router'
import { authRoutes } from '@/modules/auth'
import { accountsRoutes } from '@/modules/accounts'
import { devicesRoutes } from '@/modules/devices'
import { booksRoutes } from '@/modules/books'
import { readingsRoutes } from '@/modules/readings'
import { systemRoutes } from '@/modules/system'
import { homeRoutes } from '@/modules/home'
import { adminAccountsRoutes } from '@/admin/accounts'
import { adminDevicesRoutes } from '@/admin/devices'
import { adminAuthorsRoutes } from '@/admin/authors'
import { adminBooksRoutes } from '@/admin/books'
import { adminCategoriesRoutes } from '@/admin/categories'
import { adminReadingsRoutes } from '@/admin/readings'

const routes: RouteRecordRaw[] = [
  ...systemRoutes,
  ...authRoutes,
  ...accountsRoutes,
  ...devicesRoutes,
  ...booksRoutes,
  ...readingsRoutes,
  ...homeRoutes,
  ...adminAccountsRoutes,
  ...adminDevicesRoutes,
  ...adminAuthorsRoutes,
  ...adminBooksRoutes,
  ...adminCategoriesRoutes,
  ...adminReadingsRoutes,
]

export default routes
